<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-if="examlist && examlist.length"
            >
                <ul >
                    <li v-for="(item,index) in examlist" :key="index" @click="toexamDetial(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.coverUrl || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-main/cover-lianxi.png'" alt="">                        
                        </div>
                        <div class="learning-list-right testlist">
                            <h4>{{item.practiceName}}</h4>
                            <p class="learning-list-right-time1" >
                                来源：{{item.sourceName}}
                            </p>
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-else>
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name:'',
    data () {
        return {
            showLoading: true,
            nodata: false,
            loading:false,
            finished:false,
            examparam: {
                pageNum: 1,
                pageSize:20,
            },
            examlist: [],
            total: 0,
        };
    },
    components: {
    },
    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.examparam.pageNum = this.examparam.pageNum*1 + 1
            this.getExamList('reachBottom')
        },
        toexamDetial(val) {
            if(val.showLock){
                if(val.lockCourseRate && val.lockExamCondition===1 && val.lockFormCommit){
                    this.$toast({
                        message:`该练习未开启，开启条件为前面的课程学习进度达到 ${val.lockCourseRate}%，考试及格，表单提交`,
                        duration: 3000,
                    });
                }else if(val.lockCourseRate && val.lockExamCondition===0 && val.lockFormCommit){
                    this.$toast({
                        message:`该练习未开启，开启条件为前面的课程学习进度达到 ${val.lockCourseRate}%，表单提交`,
                        duration: 3000,
                    });
                }else if(!val.lockCourseRate && val.lockExamCondition===0 && val.lockFormCommit){
                    this.$toast({
                        message:'该练习开启，开启条件为表单提交',
                        duration: 3000,
                    });
                } else if(!val.lockCourseRate && val.lockExamCondition===1 && !val.lockFormCommit ){
                    this.$toast({
                        message:'该练习开启，开启条件为考试及格',
                        duration: 3000,
                    });
                } else if(val.lockCourseRate && val.lockExamCondition===0 && !val.lockFormCommit){
                    this.$toast({
                        message:`该练习未开启，开启条件为前面的学习内容学习进度达到 ${val.lockCourseRate}%`,
                        duration: 3000,
                    });
                } else if(val.lockCourseRate && val.lockExamCondition && !val.lockFormCommit ){
                    this.$toast({
                        message:`该练习未开启，开启条件为前面的学习内容学习进度达到 ${val.lockCourseRate}%，考试及格`,
                        duration: 3000,
                    });
                } else if(!val.lockCourseRate && val.lockExamCondition && val.lockFormCommit){
                    this.$toast({
                        message:'该练习开启，开启条件为考试及格，表单提交',
                        duration: 3000,
                    });
                }
            } else {
                this.$router.push({
                    path: '/testDetail',
                    query: {
                        businessId: val.businessId,
                        businessType: val.sourceType,
                        practiceId: val.practiceId,
                        // type:val.type,
                        backType:6,
                    }
                })
            }
        },
        selectcheck(){
            this.examparam={
                pageNum: 1,
                pageSize: 20,
            };
            this.getExamList();
        },
        getExamList(type) {
            let params = this.examparam;
            this.$api.trainTest
                .findUserExams({ params })
                .then((res) => {
                    this.showLoading = false
                    if(res.data){
                        if (type === "reachBottom") {
                        this.examlist = this.examlist.concat(res.data.list);
                        } else {
                            this.examlist = res.data.list || [];
                        }
                        this.total = res.data.total;
                        this.nodata = this.total > 0 ? false : true;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        this.finished = res.data.isLastPage;
                    }
                    

                });
        },
     
    },

    mounted(){
        
    },
}

</script>
<style lang='less'>
@import '../css/learnlist.less';
</style>